import { useEffect, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/** Route guard: only renders children for a logged-in customer. */
export default function RequireCustomer({ children }: { children: ReactNode }) {
  const { session, loading, openAuth } = useAuth();
  const isCustomer = session?.role === 'customer';

  useEffect(() => {
    if (!loading && !isCustomer) openAuth('login');
  }, [loading, isCustomer, openAuth]);

  if (loading) {
    return (
      <div className="text-fg-subtle flex min-h-[50vh] items-center justify-center">Loading…</div>
    );
  }
  if (!isCustomer) return <Navigate to="/" replace />;
  return <>{children}</>;
}
